export default "__VITE_ASSET__p74Wz9A0__"